import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { ContractModel, ContractCreateModel } from 'Pages/advertisement/models'

export const contractApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ContractModel>>(urls.advertisement.contracts, {
			params,
		})
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<ContractCreateModel>(`${urls.advertisement.contracts}/${id}`)
		return res.data
	},
	createOne: async (data: ContractCreateModel) => {
		const res = await axiosDS().post<ContractCreateModel>(urls.advertisement.contracts, {
			data,
		})
		return res.data
	},
	updateOne: async (id: string, data: ContractCreateModel) => {
		const res = await axiosDS().patch<ContractCreateModel>(
			`${urls.advertisement.contracts}/${id}`,
			{
				data,
			}
		)
		return res.data
	},
}
